import { render } from "./EmployeeDataImportModal.vue?vue&type=template&id=03a36a65&scoped=true"
import script from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"
export * from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"

import "./EmployeeDataImportModal.vue?vue&type=style&index=0&id=03a36a65&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a36a65"]])

export default __exports__